import React from 'react';
import RewardOverview from "./RewardOverview";

let RewardsListComponent = ({title, rewards, onRewardClick}) => {
	return (
		<div>
			<h1 className="title expressive">
				{title}
			</h1>
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<div className="row">
							{rewards.map((reward) =>
								<div key={reward.id} className="reward-card col-sm-12 col-md-9 col-lg-6">
									<RewardOverview title={reward.title} subtitle={reward.subtitle}
													imageFetchId={reward.imageFetchId}
													friendlyName={reward.friendlyName}
													onCardClick={() => onRewardClick(reward.friendlyName)}/>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>);
};

export default RewardsListComponent;